/** Angular Imports */
import { Component, OnInit, TemplateRef, ElementRef, ViewChild, AfterViewInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';

/** Custom Services */
import { SystemService } from '../../system.service';
import { PopoverService } from '../../../configuration-wizard/popover/popover.service';
import { PopoverRef } from '../../../configuration-wizard/popover/popover-ref';
import { ConfigurationWizardService } from '../../../configuration-wizard/configuration-wizard.service';
import { STANDALONE_SHARED_IMPORTS } from 'app/standalone-shared.module';

@Component({
  selector: 'LOSx-create-code',
  templateUrl: './create-code.component.html',
  styleUrls: ['./create-code.component.scss'],
  imports: [
    ...STANDALONE_SHARED_IMPORTS
  ]
})
export class CreateCodeComponent implements OnInit, AfterViewInit {
  private formBuilder = inject(UntypedFormBuilder);
  private systemService = inject(SystemService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private configurationWizardService = inject(ConfigurationWizardService);
  private popoverService = inject(PopoverService);

  /** Code form. */
  codeForm: UntypedFormGroup;

  /* Reference of create code form */
  @ViewChild('codeFormRef') codeFormRef: ElementRef<any>;
  /* Template for popover on create code form */
  @ViewChild('templateCodeFormRef') templateCodeFormRef: TemplateRef<any>;

  /**
   * Creates the code form.
   */
  ngOnInit() {
    this.createCodeForm();
  }

  /**
   * Creates the create code form.
   */
  createCodeForm() {
    this.codeForm = this.formBuilder.group({
      name: [
        '',
        Validators.required
      ]
    });
  }

  /**
   * Submits the code form and creates a code,
   * if successful redirects to view created code.
   */
  submit() {
    this.systemService.createCode(this.codeForm.value).subscribe((response: any) => {
      if (this.configurationWizardService.showSystemCodesForm === true) {
        this.configurationWizardService.showSystemCodesForm = false;
        this.configurationWizardService.showRolesandPermission = true;
        this.router.navigate(['/system']);
      } else {
        this.router.navigate(
          [
            '../',
            response.resourceId
          ],
          { relativeTo: this.route }
        );
      }
    });
  }

  /**
   * Popover function
   * @param template TemplateRef<any>.
   * @param target HTMLElement | ElementRef<any>.
   * @param position String.
   * @param backdrop Boolean.
   */
  showPopover(
    template: TemplateRef<any>,
    target: HTMLElement | ElementRef<any>,
    position: string,
    backdrop: boolean
  ): void {
    setTimeout(() => this.popoverService.open(template, target, position, backdrop, {}), 200);
  }

  /**
   * To show popover.
   */
  ngAfterViewInit() {
    if (this.configurationWizardService.showSystemCodesForm === true) {
      setTimeout(() => {
        this.showPopover(this.templateCodeFormRef, this.codeFormRef.nativeElement, 'right', true);
      });
    }
  }

  /**
   * Next Step (Roles and Permission) Configuration Wizard.
   */
  nextStep() {
    this.configurationWizardService.showSystemCodesForm = false;
    this.configurationWizardService.showRolesandPermission = true;
    this.router.navigate(['/system']);
  }

  /**
   * Previous Step (Manage Codes Page) Configuration Wizard.
   */
  previousStep() {
    this.configurationWizardService.showSystemCodesForm = false;
    this.configurationWizardService.showSystemCodesList = true;
    this.router.navigate(['/system/codes']);
  }
}
